'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _f3tch = require('f3tch');

var _f3tch2 = _interopRequireDefault(_f3tch);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = function () {
  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$svid = _ref.svid,
      svid = _ref$svid === undefined ? null : _ref$svid,
      _ref$driver_name = _ref.driver_name,
      driver_name = _ref$driver_name === undefined ? null : _ref$driver_name;

  var data = {
    ids: ids
  };
  if (!!svid) data.svid = svid;
  if (!!driver_name) data.driver_name = driver_name;
  return (0, _f3tch2.default)('/docs/document_zip/').profile('json').body((0, _stringify2.default)(data)).post();
};